var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',[_c('Strong',[_vm._v("Super-Wise Performance Report")]),_c('b-row',[_c('b-col',[_c('b-table',{attrs:{"show-empty":"","stacked":"md","items":_vm.items,"fields":_vm.fields}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }